import dayjs from "dayjs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { PDF } from "./MonasteryProgressModal.constants";

export const buildInitialLessons = (count) =>
  Array.from({ length: count }, (_, index) => ({
    lessonNumber: index + 1,
    startDate: null,
    profiencyDate: null,
  }));

export const generateProgressPdf = (lessons) => {
  const doc = new jsPDF();

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(PDF.title, 14, 20);

  autoTable(doc, {
    startY: 30,
    head: [["Lesson Number", "Starting Date", "Date of Proficiency"]],
    body: lessons.map(({ lessonNumber, startDate, profiencyDate }) => [
      lessonNumber,
      startDate ? dayjs(startDate).format("YYYY-MM-DD") : "N/A",
      profiencyDate ? dayjs(profiencyDate).format("YYYY-MM-DD") : "N/A",
    ]),
    theme: "grid",
    styles: {
      fontSize: 10,
      cellPadding: 3,
    },
    headStyles: {
      fillColor: [73, 42, 24],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
  });

  const pageHeight = doc.internal.pageSize.height;
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.text(PDF.emailText, 14, pageHeight - 10);

  doc.save(PDF.filename);
};
